import { useMutation } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import {
  GenerateJobKeywordSuggestionsRequest,
  GenerateJobKeywordSuggestionsResponse,
  HttpResponse,
} from "@/types";

export const useGenerateJobKeywordSuggestions = () => {
  return useMutation({
    mutationFn: async (
      request: GenerateJobKeywordSuggestionsRequest,
    ): Promise<GenerateJobKeywordSuggestionsResponse> => {
      const res = await guacHttpClient.post<
        GenerateJobKeywordSuggestionsResponse,
        HttpResponse<GenerateJobKeywordSuggestionsResponse>,
        GenerateJobKeywordSuggestionsRequest
      >("jobs/keyword-suggestions", request);

      return res.data;
    },
  });
};
